import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotfoundPageComponent } from './notfound-page/notfound-page.component';
import { RouterModule } from '@angular/router';
import { GlobalServicesModule } from '../../global_services/global-services.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GlobalServicesModule
  ],
  declarations: [NotfoundPageComponent],
  bootstrap: [NotfoundPageComponent]
})
export class NotfoundPageModule { }

/*
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotfoundPageComponent } from './notfound-page/notfound-page.component';
import { RouterModule } from '@angular/router';
import { GlobalServicesModule } from '../../global_services/global-services.module';

export const NotfoundPageRoutes = [
                                    { path: '404', component: NotfoundPageComponent}
                                ];

@NgModule({
  imports: [
    CommonModule,
    GlobalServicesModule,
    RouterModule.forChild(NotfoundPageRoutes)
  ],
  declarations: [NotfoundPageComponent]
})
export class NotfoundPageModule { }
*/